/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { ISearchDevelopersRequest, TSearchDevelopersModel, IMappers, TSearchDevelopersResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ISearchDevelopersResponse } from '../../entities/search_developers/SearchDevelopersResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createSearchDevelopersModel(parameters: ISearchDevelopersRequest): TSearchDevelopersModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'developer-card',
    pathApi: '/v1/search-developers/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface ISearchDevelopersOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: ISearchDevelopersRequest;
}

export async function fetchSearchDevelopers<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISearchDevelopersOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TSearchDevelopersResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createSearchDevelopersModel(parameters),
    config,
  )) as FetchResponse<TSearchDevelopersResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISearchDevelopersResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TSearchDevelopersResponse>;
}
